import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { InvoiceSearch } from '../models/invoiceSearch.model';
import { InvoiceSearchResult } from '../models/invoiceSearchResult.model';


@Injectable({  
  providedIn: 'root'  
}) 

@Injectable({
  providedIn: 'root'
})
export class VendorInvoiceFormService {

  //apiUrl: string = "http://localhost:49850/Api/User/";      
  constructor(private http: HttpClient) {}

  public GetInvoiceDetails(VendorNumber : string,InvoiceNumber : string): Observable<InvoiceSearchResult> {
    let params = new HttpParams().set('VendorNumber', VendorNumber).set('InvoiceNumber',InvoiceNumber);
    return this.http.get<InvoiceSearchResult>('api/InvoiceSearch', {params:params}).pipe(
      retry(1),
      catchError(this.handleError)
  );
  }
  handleError(error){
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
